import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { getBackHost } from "../../../util/server-util";

@Injectable()
export class MenuService {
  sistema: string;

  constructor(private readonly http: HttpClient) {}

  getUserMenu(): Observable<any> {
    return this.http.get(getBackHost("../internal/v1/security/menu"));
  }
}
